// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BAZAAR_SEO_BABY = "Baz\u00e1r";
export const FROM_SELLER = "od pred\u00e1vaj\u00facej";
